import { useContext } from 'react';
import {
  RequestDetailsApproval,
  RequestDetailsApprovalBy,
  RequestDetailsApprovalByMobile,
  RequestDetailsApprovalComment,
  RequestDetailsApprovalContainerStyle,
  RequestDetailsApprovalParagraph,
  RequestDetailsApprovalPersona,
  RequestDetailsApprovalPersonaContainer,
  RequestDetailsApprovalPersonaText,
  RequestDetailsApprovalStatusContainer,
} from './styles/RequestDetailsApprovalContainer.styled';
import {
  RequestDetailsStatusContainer,
  RequestDetailsStatusTitle,
} from './styles/RequestDetailsShared.style';
import { PersonaSize } from '@fluentui/react';
import { formatDate } from 'src/utils/dateFns/formatDate';
import { Tooltip } from '@fluentui/react-components';
import { truncateString } from 'src/utils/truncateString';
import { TeamsFxContext } from 'src/context/TeamsContext';

interface RequestDetailsApprovalContainerProps {
  approvedStatus: boolean;
  approvedBy: string;
  approvalDate: string;
  approvalComment: string;
  vacationStatus: string;
}

export const RequestDetailsApprovalContainer = ({
  approvalComment,
  approvalDate,
  approvedBy,
  approvedStatus,
  vacationStatus,
}: RequestDetailsApprovalContainerProps) => {
  const { isMobile } = useContext(TeamsFxContext);
  const { day, month, year } = formatDate(new Date(approvalDate));
  const isApproved =
    vacationStatus === 'Rejected' ? 'Rejected by:' : 'Approved by:';

  const RequestDetailsApprovalView = () => (
    <>
      <RequestDetailsStatusTitle>{isApproved}</RequestDetailsStatusTitle>
      {approvedBy ? (
        <Tooltip relationship="description" content={approvedBy}>
          <RequestDetailsApprovalPersonaContainer>
            <RequestDetailsApprovalPersona
              text={approvedBy}
              size={PersonaSize.size24}
            />
            <RequestDetailsApprovalPersonaText>
              {isMobile ? truncateString(approvedBy, 14) : approvedBy}
            </RequestDetailsApprovalPersonaText>
          </RequestDetailsApprovalPersonaContainer>
        </Tooltip>
      ) : (
        <RequestDetailsApprovalParagraph>--</RequestDetailsApprovalParagraph>
      )}
    </>
  );

  return (
    <RequestDetailsApprovalContainerStyle>
      <RequestDetailsApprovalStatusContainer>
        <RequestDetailsApproval>
          <RequestDetailsStatusTitle>Approved:</RequestDetailsStatusTitle>
          <RequestDetailsApprovalParagraph>
            {approvedStatus ? approvedStatus : '--'}
          </RequestDetailsApprovalParagraph>
        </RequestDetailsApproval>
        <RequestDetailsApprovalBy>
          <RequestDetailsApprovalView />
        </RequestDetailsApprovalBy>
        <RequestDetailsApproval>
          <RequestDetailsStatusTitle>Approval Date:</RequestDetailsStatusTitle>
          <RequestDetailsApprovalParagraph>
            {approvalDate ? `${day}/${month}/${year}` : '--'}
          </RequestDetailsApprovalParagraph>
        </RequestDetailsApproval>
      </RequestDetailsApprovalStatusContainer>
      <RequestDetailsApprovalByMobile>
        <RequestDetailsApprovalView />
      </RequestDetailsApprovalByMobile>
      <RequestDetailsStatusContainer>
        <RequestDetailsStatusTitle>
          Approval Comments:
        </RequestDetailsStatusTitle>
        <RequestDetailsApprovalComment>
          {approvalComment ?? 'No additional comments'}
        </RequestDetailsApprovalComment>
      </RequestDetailsStatusContainer>
    </RequestDetailsApprovalContainerStyle>
  );
};
